import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from '@ui/components';
import moment from 'moment';

import { useUser } from '@util/providers/AuthProvider';

import LogInButton from '@components/Account/LogInButton';

const UserMenu = () => {
  const { t } = useTranslation();
  const { ssoUser, signOut } = useUser();

  if (!ssoUser)
    return (
      <LogInButton className="block cursor-pointer border-0 bg-transparent px-3 py-2 text-base text-info no-underline whitespace-nowrap hover:underline focus:outline-none" />
    );

  if (ssoUser)
    return (
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle
          data-testid="UserMenuDropdown"
          nav
          caret
          title={`expires: ${moment(ssoUser.expires_at * 1000).format('l LTS')}`}
        >
          {ssoUser.given_name}
        </DropdownToggle>
        <DropdownMenu right className="mb-4 md:mb-0">
          <DropdownItem data-testid="UserMenuDropdownLogOut" onClick={signOut}>
            {t('account.logOut')}
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
};

export default UserMenu;
